import gql from 'graphql-tag'

/**
 * Playlists live in the `api` subgraph now, as root queries rather than fields
 * on `workspace`. Pass `page: 0` to get every match in one response — that is
 * what the pickers need, and the old 50-per-page default is what hid playlists
 * from them (RD-7540).
 */
export const GET_PRESENTATIONS_QUERY = gql`
  query GetPresentation(
    $workspaceId: String!
    $page: Int
    $limit: Int
    $sort: String
    $filters: PresentationFiltersDTO
  ) {
    presentations(
      queryPresentationsDTO: {
        workspaceId: $workspaceId
        page: $page
        limit: $limit
        sort: $sort
        filters: $filters
      }
    ) {
      page
      count
      values {
        id
        name
        config
        createdAt
        updatedAt
        thumb
        defaultSlideDuration
        tags
        type
        isMediaProcessing
      }
    }
  }
`

export const PL_GET_PRESENTATION_Q = gql`
  query PlGetPresentationQuery($workspaceId: String!, $id: String!) {
    presentationById(getPresentationDTO: { workspaceId: $workspaceId, id: $id }) {
      id
      name
      config
      slides
      slidesOrder
      defaultSlideDuration
      tags
      type
      isMediaProcessing
    }
  }
`

export const PL_GET_PRESENTATION_TAGS_Q = gql`
  query PlGetPresentationTagsQuery($workspaceId: String!) {
    presentationTags(queryWorkspacePresentationsDTO: { workspaceId: $workspaceId })
  }
`

export const PL_GET_DISPLAY_DIMENSIONS_Q = gql`
  query PlGetDisplayDimensions($workspaceId: String!) {
    presentationDimensionsUsed(queryWorkspacePresentationsDTO: { workspaceId: $workspaceId }) {
      width
      height
    }
  }
`

export const PL_SEARCH_UNSPLASH_Q = gql`
  query PlSearchUnsplashQuery($q: String) {
    unsplash(q: $q)
  }
`

export const PL_SEARCH_GIPHY_Q = gql`
  query PlSearchGiphyQuery($q: String) {
    giphy(q: $q)
  }
`

/**
 * Every caller of this one is a picker — a Default Playlist dropdown, the event
 * scheduler, the playbook dialogs — so it always asks for the full list.
 */
export const PL_GET_PRESENTATIONS_DISPLAY_Q = gql`
  query PlGetPresentationsDisplay($workspaceId: String!, $filters: PresentationFiltersDTO) {
    presentations(
      queryPresentationsDTO: { workspaceId: $workspaceId, page: 0, filters: $filters }
    ) {
      page
      count
      values {
        id
        name
        config
        updatedAt
        type
        isMediaProcessing
      }
    }
  }
`

export const PL_GET_PEXELS_VIDEO_QUERY = gql`
  query GetPexelsVideo($queryKeyword: String!, $page: Int) {
    pexelsVideosMeta(pexelsMediaQueryDTO: { queryKeyword: $queryKeyword, page: $page }) {
      resultCount
      pageCount
      videos {
        hdVideoId
        hdVideoUrl
        sdVideoId
        sdVideoUrl
      }
    }
  }
`

export const PL_GET_PEXELS_IMAGE_QUERY = gql`
  query GetPexelsImage($queryKeyword: String!, $page: Int) {
    pexelsImagesMeta(pexelsMediaQueryDTO: { queryKeyword: $queryKeyword, page: $page }) {
      resultCount
      pageCount
      images {
        imageId
        imageUrl
        thumbnailUrl
      }
    }
  }
`

export const PL_GET_PUBLIC_PRESENTATION_LIST_Q = gql`
  query PlGetPublicPresentationList(
    $getPublicPresentationPaginationListDTO: GetPublicPresentationPaginationListDTO!
  ) {
    getPublicPresentationList(
      GetPublicPresentationPaginationListDTO: $getPublicPresentationPaginationListDTO
    ) {
      templates {
        id
        name
        thumb
      }
      total
      hasMore
      currentPage
      totalFetched
    }
  }
`

export const PL_GET_PUBLIC_PRESENTATION_Q = gql`
  query PlGetPublicPresentation($getPublicPresentationDTO: GetPublicPresentationDTO!) {
    getPublicPresentation(GetPublicPresentationDTO: $getPublicPresentationDTO) {
      id
      name
      config
      slides
      slidesOrder
    }
  }
`

export const PL_SEARCH_PUBLIC_PRESENTATIONS_Q = gql`
  query PlSearchPublicPresentations(
    $searchPublicPresentationsPaginationDTO: SearchPublicPresentationsPaginationDTO!
  ) {
    searchPublicPresentations(
      SearchPublicPresentationsPaginationDTO: $searchPublicPresentationsPaginationDTO
    ) {
      templates {
        id
        name
        thumb
      }
      total
      hasMore
      currentPage
      totalFetched
    }
  }
`
